const Purposes = () => {
  return (
    <>
      <div className="px-5 mb-5">
        <h2 className="text-center mb-2 text-4xl font-bold">
          Purpose of the API
        </h2>
        <div className="header-underline"></div>
        <p className="my-3 text-center md:max-w-xl md:mx-auto lg:max-w-3xl">
          This API serves to honour prominent black people, both alive and
          passed, who were instrumental in the freedom we enjoy today. It also
          serves to honour all black people. As much as racism exists, we cannot
          exist without each other. Credit to Wikipedia, the source of this
          information.
        </p>
      </div>
    </>
  );
};

export default Purposes;
